import { Sorter } from '@spike/appointments-list-model';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import { bookedAtSorter, clientSorter, petSorter, serviceSorter, statusSorter, totalSorter } from './sorting';

interface AllHeaderTableProps {
    hideClientHeader?: boolean;
    sorter: Sorter | null;
    onSort?: (sorter: Sorter) => void;
}

export const AllHeaderTable: FunctionComponent<AllHeaderTableProps> = props => {
    return (
        <TableHeader>
            {!props.hideClientHeader && (
                <HeaderTableColumn
                    columnSorter={clientSorter}
                    selectedSorter={props.sorter}
                    onSort={props.onSort}
                >
                    Client Name
                </HeaderTableColumn>
            )}
            <HeaderTableColumn
                columnSorter={petSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={serviceSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={bookedAtSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={totalSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
            <HeaderTableColumn
                columnSorter={statusSorter}
                selectedSorter={props.sorter}
                onSort={props.onSort}
            >
                Status
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default AllHeaderTable;
